import styles from "./Title.css.ts";

/**
 * A function that renders the title.
 *
 * @param {Object} spark - The spark object
 * @returns {JSX.Element} - The rendered title component
 */
export const Title = ({ title }) => {
  return (
    <span data-cy="cy-workshopansicht-heading" id="title">
      <h1 className={styles.titleText}>{title}</h1>
    </span>
  );
};
